import Templates from './templates';
import ProductDetails from './ProductDetails';

export default {
  Templates,
  ProductDetails,
};
